import React, { FC } from 'react';
import cx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow, { TableRowProps } from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import { ColumnProps } from './LwtTable';

const useStyles = makeStyles<Theme>((theme: Theme) => {
  return {
    checkboxCell: {
      width: '0.2rem',
      padding: 0,
      paddingLeft: theme.spacing(2),
      paddingBottom: theme.spacing(0.5)
    },
    checkBox: {
      width: '14px',
      height: '14px',
      borderRadius: '1px',
      fontSize: '0.5rem',
      padding: 0,
      boxShadow: `0 0 0 1px ${theme.palette.secondary.main}`,
      color: 'transparent'
    },
    cell: {
      width: '200px',
      paddingLeft: 0,
      paddingRight: 0,
      fontSize: '0.9rem'
    },
    firstCell: {
      width: '200px',
      fontSize: '0.95rem',
      fontWeight: 600,
      paddingRight: 0,
      paddingLeft: theme.spacing(1.5)
    },
    thumbnail: {
      maxHeight: '26px',
      maxWidth: '26px'
    },
    padIcon: {
      paddingRight: theme.spacing(0.75)
    },
    noBorder: {
      border: 'none'
    },
    icons: {
      width: '75px'
    },
    input: {
      height: '15px',
      width: '15px'
    },
    gray: {
      backgroundColor: theme.palette.grey[200]
    },
    disabled: {
      color: theme.palette.secondary.main
    }
  };
});

export interface RowProps extends Omit<TableRowProps, 'children'> {
  rowData: any;
  noCellBorder?: boolean;
  handleCheck?: React.ChangeEventHandler<HTMLInputElement>;
  handleRowClick?: any; // TODO: type
  enableCheck?: boolean;
  checked?: boolean;
  readOnly?: boolean;
  label?: string;
  id?: string;
  className?: string;
  columns: ColumnProps<any>[];
  style?: any;
  rowProps?: (item: any, idx: number) => TableRowProps;
  rowDataIndex: number;
}

const TableDataRow: FC<RowProps> = ({
  id,
  label,
  readOnly,
  noCellBorder,
  enableCheck,
  checked,
  rowData,
  rowDataIndex,
  handleCheck,
  handleRowClick,
  className,
  columns,
  rowProps
}) => {
  const classes = useStyles();
  const borderless = { [classes.noBorder]: noCellBorder };
  const gray = { [classes.gray]: checked };

  return (
    <TableRow
      className={cx(classes.noBorder, className)}
      onClick={handleRowClick}
      {...rowProps?.(rowData, rowDataIndex)}
    >
      {enableCheck && (
        <TableCell className={cx(classes.checkboxCell, borderless, gray)}>
          <Checkbox
            value={id}
            disabled={readOnly}
            aria-label={`${label} Checkbox`}
            aria-checked={checked}
            aria-disabled={readOnly}
            checked={checked}
            onChange={handleCheck}
            classes={{
              disabled: classes.disabled
            }}
            className={classes.checkBox}
            size="small"
            color="secondary"
          />
        </TableCell>
      )}
      {columns.map((col, idx) => {
        return (
          <TableCell
            key={`${col.label}_${idx}-table-row-data`}
            className={cx(classes.firstCell, borderless, gray)}
          >
            {col.getValue(rowData, idx)}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default TableDataRow;
